/** Accept named IANA zones, including UTC aliases, but never fixed UTC offsets. */
export const isIanaTimeZone = (value: string): boolean => {
  if (/^[+-]/.test(value)) return false;

  try {
    new Intl.DateTimeFormat('en', { timeZone: value });
    return true;
  } catch {
    return false;
  }
};
